import { deleteFeild, editFeild, createFeild } from "../../api/field/modal.js";
import { Delete } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, Switch, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Dropdown, Modal, TextInput, UploadImage } from "../../../../shared/ui/common/index.js";

import Confirm from "../../../../shared/ui/modals/Confirm.jsx";
import { DELETE_FEILD_IMAGE } from "../../../../shared/api/endpoints.js";
import { FEILD_TYPE, FILTER_TYPE } from "../../../../shared/lib/constants.js";

import { logout } from "../../../../shared/state/slices/user.js";
const FeildModal = ({
  open,
  close,
  data = {},
  forEdit,
  setAllRows,
  allRows,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const [selectedProductImage, setselectedProductImage] = useState();
  const { userPermissions } = useSelector((state) => state.relationals);

  const [loading, setLoading] = useState(false);
  const [prevData, setPrevData] = useState({ required: true });
  const [openDelete, setOpenDelete] = useState(false);

  // set data
  useEffect(() => {
    if (forEdit) {
      setPrevData({
        ...data,
      });
    } else {
      resetData();
    }
  }, [allRows, data, forEdit]);
  const resetData = () => {
    setPrevData({ required: true });
  };
  const deleteCategory = () => {
    if (data) {
      setLoading(true);
      deleteFeild(data, token)
        .then((res) => {
          setLoading(false);
          setOpenDelete(false);
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };

  const editItem = () => {
    const formData = new FormData();
    console.log(prevData, "prevDataprevData");
    formData.append("title", prevData?.title);
    formData.append("description", prevData?.description);
    if (prevData?.avatar) formData.append("files", prevData?.avatar);
    if (selectedProductImage)
      formData.append("fromGallery", selectedProductImage);
    formData.append("required", prevData?.required ? true : false);
    formData.append("placeHolder", prevData?.placeHolder);
    formData.append("filterable", prevData?.filterable ? true : false);
    if (prevData?.fieldType) formData.append("fieldType", prevData?.fieldType);
    if (prevData?.filterType)
      formData.append("filterType", prevData?.filterType);

    if (forEdit) {
      formData.append("id", prevData?.id);
    }
    var temp = [...allRows];
    if (prevData?.title) {
      setLoading(true);
      if (forEdit) {
        editFeild(formData, token)
          .then((res) => {
            setLoading(false);
            toast.success("با موفقیت ویرایش شد");
            var index = temp.findIndex((item) => item.id === data.id);
            temp[index] = res.data.data;
            setAllRows(temp);
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      } else {
        createFeild(formData, token)
          .then((res) => {
            temp.unshift(res.data.data);

            setAllRows(temp);
            setLoading(false);
            toast.success("با موفقیت اضافه شد");
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      }
    } else if (!prevData?.title) {
      toast.error("نام فیلد را وارد کنید");
    }
  };
  const removedImage = () => {
    var temp = [...allRows];
    var index = temp.findIndex((item) => item.id === data.id);
    temp[index] = { ...data, galleryId: null };
    setAllRows(temp);
  };
  return (
    <Modal
      open={open}
      close={close}
      title={` ${forEdit ? "ویرایش" : "افزودن"}  فیلد ها
    `}
    >
      <TextInput
        label="نام فیلد جدید"
        change={(e) => setPrevData({ ...prevData, title: e })}
        currentValue={prevData?.title}
      />
      <Dropdown
        value={FEILD_TYPE?.find((item) => item?.id === prevData?.fieldType)}
        change={(e) => setPrevData({ ...prevData, fieldType: e?.id })}
        data={FEILD_TYPE}
        title=" نوع"
        emptyValue={true}
      />{" "}
      <TextInput
        label="  placeHolder"
        change={(e) => setPrevData({ ...prevData, placeHolder: e })}
        currentValue={prevData?.placeHolder}
      />
      <TextField
        multiline
        label="توضیحات"
        value={prevData?.description ?? ""}
        onChange={(e) =>
          setPrevData({ ...prevData, description: e.target.value })
        }
        sx={{ width: "100%" }}
        rows={2}
      />
      <div className="flex flex-wrap items-center gap-3">
        <span>قابل فیلتر شدن : </span>
        <Switch
          checked={Boolean(prevData?.filterable)}
          onChange={(e) =>
            setPrevData({ ...prevData, filterable: !prevData?.filterable })
          }
        />
        <span>اجباری : </span>
        <Switch
          checked={Boolean(prevData?.required)}
          onChange={(e) =>
            setPrevData({ ...prevData, required: !prevData?.required })
          }
        />
      </div>
      {prevData?.filterable && (
        <Dropdown
          value={FILTER_TYPE?.find((item) => item?.id === prevData?.filterType)}
          change={(e) => setPrevData({ ...prevData, filterType: e?.id })}
          data={FILTER_TYPE}
          title=" نوع فیلتر"
          emptyValue={true}
        />
      )}
      <UploadImage
        file={prevData?.avatar}
        change={(e) => setPrevData({ ...prevData, avatar: e })}
        address={data.galleryId ? data.galleryId : false}
        selectedProductImage={selectedProductImage}
        setselectedProductImage={setselectedProductImage}
        removeApi={DELETE_FEILD_IMAGE}
        id={data.id}
        hasRemoved={removedImage}
      />
      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={editItem}
          disabled={loading}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این فیلد اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteCategory}
        open={openDelete}
      />
    </Modal>
  );
};

export default FeildModal;
